
import { Vue, Component } from 'vue-property-decorator';
import { Toast, Popup } from 'vant';

@Component
export default class SlideVerify extends Vue {
  appKey = 'FFFF000000000168EBF9';
  modelName = 'no-captcha';
  ncToken = '';
  csessionid = '';
  sig = '';
  lang = 'cn';
  NCOpt = {};

  mounted() {
    this.init();
  }

  init() {
    const ncToken = [
      'FFFF000000000168EBF9',
      new Date().getTime(),
      Math.random(),
    ].join(':');
    this.NCOpt = {
      renderTo: '#nc', // 渲染到该DOM ID指定的Div位置
      appkey: 'FFFF000000000168EBF9', // 应用标识,不可更改
      scene: 'activity_h5', // 场景,不可更改
      // token: ["FFFF000000000168EBF9", (new Date()).getTime(), Math.random()].join(':'),
      token: ncToken,
      callback: (data: any) => {
        // 校验成功回调
        this.ncToken = ncToken;
        this.csessionid = data.csessionid;
        this.sig = data.sig;
        const SlideData = {
          token: ncToken,
          sessionid: data.csessionid,
          sig: data.sig,
          scene: 'activity_h5',
        };
        this.$emit('getSlideData', SlideData);
      },
    };
    this.generarte();
  }
  generarte() {
    const nc = new (window.NoCaptcha.init as any)(this.NCOpt);
    nc.setEnabled(true);
    nc.reset();
  }
}
